export default {
  title: 'Importul este în curs... 🙂',
  description: 'Notificările Slack vor fi trimise când importul este finalizat.',
  buttons: {
    open_followers_list: 'Deschide lista de urmăritori',
  },
};
